export default [
  {
    path: '/newAttractFansList', name: 'newAttractFansList', component: () => import('@/pages/activity/newAttractFans/newAttractFansList'), meta: { title: '吸粉活动' },
  },
  {
    path: '/newAttractFansMachineDetail', name: 'newAttractFansMachineDetail', component: () => import('@/pages/activity/newAttractFans/newAttractFansMachineDetail'), meta: { title: '吸粉活动' },
  },
  {
    path: '/newAttractFansMachineList', name: 'newAttractFansMachineList', component: () => import('@/pages/activity/newAttractFans/newAttractFansMachineList'), meta: { title: '吸粉活动' },
  },
  {
    path: '/newAttractFansQrcode', name: 'newAttractFansQrcode', component: () => import('@/pages/activity/newAttractFans/newAttractFansQrcode'), meta: { title: '吸粉活动' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/newAttractFans.js